<template>
    <div class="text-center generic-error-container d-flex justify-content-center align-items-center flex-column">
        <span class="text-danger generic-error-icon">
            <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'times' }"/>
        </span>
        <span class="generic-error-text">{{text}}</span>
    </div>
</template>
<script>
export default {
  name: 'server-error',
  props: {
    text: {
      required: false,
      default: 'The web server is currently unavailable, please try again later.'
    }
  }
}
</script>
<style>
    .generic-error-container{
        height:300px;
    }
</style>
